/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Total_FoundInputs */

const en_portal_scanner_total_found = /** @type {(inputs: Portal_Scanner_Total_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Found`)
};

const de_portal_scanner_total_found = /** @type {(inputs: Portal_Scanner_Total_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Found`)
};

const fr_portal_scanner_total_found = /** @type {(inputs: Portal_Scanner_Total_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Found`)
};

const es_portal_scanner_total_found = /** @type {(inputs: Portal_Scanner_Total_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Found`)
};

const it_portal_scanner_total_found = /** @type {(inputs: Portal_Scanner_Total_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Found`)
};

const nl_portal_scanner_total_found = /** @type {(inputs: Portal_Scanner_Total_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Found`)
};

const pl_portal_scanner_total_found = /** @type {(inputs: Portal_Scanner_Total_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Found`)
};

const fi_portal_scanner_total_found = /** @type {(inputs: Portal_Scanner_Total_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Found`)
};

const da_portal_scanner_total_found = /** @type {(inputs: Portal_Scanner_Total_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Found`)
};

const sv_portal_scanner_total_found = /** @type {(inputs: Portal_Scanner_Total_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Found`)
};

/**
* | output |
* | --- |
* | "Total Found" |
*
* @param {Portal_Scanner_Total_FoundInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_total_found = /** @type {((inputs?: Portal_Scanner_Total_FoundInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Total_FoundInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_total_found(inputs)
	if (locale === "fr") return fr_portal_scanner_total_found(inputs)
	if (locale === "es") return es_portal_scanner_total_found(inputs)
	if (locale === "it") return it_portal_scanner_total_found(inputs)
	if (locale === "nl") return nl_portal_scanner_total_found(inputs)
	if (locale === "pl") return pl_portal_scanner_total_found(inputs)
	if (locale === "fi") return fi_portal_scanner_total_found(inputs)
	if (locale === "da") return da_portal_scanner_total_found(inputs)
	if (locale === "sv") return sv_portal_scanner_total_found(inputs)
	return en_portal_scanner_total_found(inputs)
});